import React, { useState, useContext } from "react";
import { useInterviews } from "../../contexts/InterviewsContext";
import { useMyInterviews } from "../../contexts/MyInterviewsContext";
import { AuthContext } from "../../contexts/AuthContext";
import ReusableTable from "../../components/UI/ReusableTable";
import Drawer from "../../components/UI/Drawer";
import CandidateDetails from "../../components/Details/CandidateDetails";
import Notification from "../../components/UI/Notification";
import ReactPaginate from 'react-paginate';

const MyScheduledInterviews = () => {
    const { updateInterviewStatus } = useInterviews();
    const { interviews, fetchMyInterviews, updateMyInterviewStatus, pagination, loading } = useMyInterviews();
    const { user } = useContext(AuthContext);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [selectedInterview, setSelectedInterview] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [notification, setNotification] = useState(null);
    const [isFiltering, setIsFiltering] = useState(false);
    
    const openDetailsDrawer = (interview) => {
        setSelectedInterview(interview); // Set the full interview object
        setIsDrawerOpen(true);
    };

    const closeDetailsDrawer = () => {
        setIsDrawerOpen(false);
        setSelectedInterview(null);
    };

    const handleStatusUpdate = async (feedback) => {
        // console.log("feedback", feedback)
        if (!selectedInterview) return;
        
        // console.log("Updating status for:", selectedInterview.id, "with:", feedback);
    
        try {
            await updateInterviewStatus(selectedInterview.id, feedback);
            setNotification("Interview status update successfully.")
            closeDetailsDrawer();
        } catch (error) {
            // console.error("Error updating interview status:", error);
            setNotification("Error updating interview status:", error);
        }
    };    

    const getColumns = (currentPage, pageSize) => [
        { label: "Sr. No", field: "sr_no",
            render: (_row, idx) => (currentPage - 1) * pageSize + idx + 1,
        },
        {
            label: "Candidate Name",
            field: "candidate_name",
            render: (row) => (
                <button
                    onClick={() => openDetailsDrawer(row)}
                    className="text-blue-600 hover:underline"
                >
                    {row.candidate?.name || "Unknown Candidate"}
                </button>
            ),
        },
        { label: "Interviewer", field: "interviewer" },
        {
            label: "Scheduled At",
            field: "scheduled_at",
            render: (row) =>
                new Date(row.scheduled_at).toLocaleString("en-US", {
                    dateStyle: "medium",
                    timeStyle: "short",
                }),
        },
        { label: "Status", field: "status" },
    ];

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
          setCurrentPage(newPage);
          fetchMyInterviews(newPage);
        }
    };
      
    return (
        <div className="px-3 py-2 bg-white dark:bg-gray-900 font-poppins rounded-lg">
            
            {/* notification compo */}
            {notification && (
                <Notification message={notification} onClose={() => setNotification(null)} />
            )}

            {/* Page Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
                <h2 className="text-2xl font-semibold text-gray-800 dark:text-white">
                    My Scheduled Interviews
                </h2>
            </div>

            {/* Interviews Table or Empty State */}
            <div>
                <ReusableTable
                    data={interviews}
                    // columns={columns}
                    loading={loading}
                    filterable={true}
                    columns={getColumns(currentPage, pagination.perPage)}
                    onFilterChange={(filtering) => setIsFiltering(filtering)}
                />

                {!isFiltering && interviews?.length > 0 && (
                    <ReactPaginate
                        breakLabel="..."
                        onPageChange={(event) => handlePageChange(event.selected + 1)}
                        forcePage={currentPage - 1}
                        pageRangeDisplayed={5}
                        pageCount={pagination.totalPages}
                        renderOnZeroPageCount={null}
                        nextLabel="Next >"
                        previousLabel="< Prev"
                        previousClassName='dark:text-white px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-50 dark:border-gray-600 dark:hover:bg-gray-800'
                        nextClassName="dark:text-white px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-50 dark:border-gray-600 dark:hover:bg-gray-800"
                        containerClassName="flex items-center justify-center mt-4"
                        pageClassName="mx-1 px-3 py-1 border rounded"
                        activeClassName="bg-blue-500 text-white"
                    />
                )}
            </div>

            {/* Drawer for Candidate Details */}
            
            <Drawer
                isOpen={isDrawerOpen}
                onClose={closeDetailsDrawer}
                ChilDiv=""
                ChildParent=""
                showClose = {false}
                border_radius="md:rounded-none"
            >
                {selectedInterview ? (
                    <CandidateDetails
                        candidate={selectedInterview.candidate} // Pass candidate details
                        interview={selectedInterview} // Pass the full interview object
                        onUpdateStatus={handleStatusUpdate}
                        onClose={closeDetailsDrawer}
                    />
                ) : (
                    <p className="text-center text-gray-500">
                        
                    </p>
                )}
            </Drawer>
        </div>
    );
};

export default MyScheduledInterviews;
